var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.641,
    height: 18.004,
    viewBox: "0 0 15.641 18.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-tiktok",
    "data-name": "Icon simple-tiktok",
    d: "M10.583.015C11.566,0,12.541.008,13.517,0a4.672,4.672,0,0,0,1.313,3.128A5.29,5.29,0,0,0,18.01,4.471V7.494a8.029,8.029,0,0,1-3.151-.728,9.268,9.268,0,0,1-1.215-.7c-.007,2.19.008,4.381-.015,6.564a5.73,5.73,0,0,1-1.013,2.956A5.589,5.589,0,0,1,8.183,18a5.47,5.47,0,0,1-3.061-.773A5.657,5.657,0,0,1,2.384,12.94c-.015-.375-.023-.75-.008-1.118A5.647,5.647,0,0,1,8.926,6.811c.015,1.11-.03,2.22-.03,3.331a2.574,2.574,0,0,0-3.286,1.59A2.976,2.976,0,0,0,5.5,12.94,2.553,2.553,0,0,0,8.13,15.093a2.52,2.52,0,0,0,2.078-1.208,1.731,1.731,0,0,0,.308-.8c.075-1.343.045-2.678.053-4.021.008-3.023-.008-6.039.015-9.054Z",
    transform: "translate(-2.369)",
    fill: "#5e5e5e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokGrey);
export default __webpack_public_path__ + "static/media/tiktok_grey.facb9bc00471520be72093ec7f81b129.svg";
export { ForwardRef as ReactComponent };